//@ts-check
import * as d3 from "d3";

/**
 * Translate the loaded 2D drawing on x and y axis using drawing id.
 * @param {string} drawingId Pass the drawing id for translating the drawing
 * @param {number} translateDrawingOnXAxis Pass the value to translate on x axis
 * @param {number} translateDrawingOnYAxis Pass the value to translate on y axis
 * @returns {Object} Return success or error messages 
 */
export function translateDrawing(drawingId, translateDrawingOnXAxis, translateDrawingOnYAxis) {
  try {
    let scope = this;
    if (scope.canvas && scope.canvas.children.length != 0) {
      d3.select('#' + scope.canvas.id).selectAll('#group').each(function () {
        if (scope.getAttribute('name') === drawingId) {

          let previousTransformValue = scope.getAttribute('transform');
          let previousScaleAndRotationValue = previousTransformValue.substring(previousTransformValue.indexOf(')') + 1, previousTransformValue.lastIndexOf(')') + 1);

          d3.select(this)
            .attr('transform', 'translate(' + translateDrawingOnXAxis + ',' + translateDrawingOnYAxis + ')' + previousScaleAndRotationValue);
        }
      });
      return {
        'status': 'success',
        'message': 'Translated the drawing.'
      }
    }
  }
  catch (err) {
    return {
      'status': 'failed',
      'message': 'Failed to translate the drawing.' + err.message
    }
  }
}

/**
 * Rotate the loaded 2D drawing on x and y axis using drawing id.
 * @param {string} drawingId Pass the drawing id for rotating the drawing
 * @param {number} rotationAngle Pass the value to rotate drawing on specific angle
 * @returns {Object} Return success or error messages 
 */
export function rotateDrawing(drawingId, rotationAngle) {
  try {
    let scope = this;
    if (scope.canvas && scope.canvas.children.length != 0) {
      d3.select('#' + scope.canvas.id).selectAll('#group').each(function () {
        if (scope.getAttribute('name') === drawingId) {
          let drawingBoundingBox = d3.select(scope).node().getBBox();
          let x1 = drawingBoundingBox.x + drawingBoundingBox.width / 2;
          let y1 = drawingBoundingBox.y + drawingBoundingBox.height / 2;
          let previousTranslation = scope.getAttribute('transform');
          d3.select(scope)
            .attr('transform', previousTranslation + `rotate(${rotationAngle}, ${x1}, ${y1})`)
        }
      });
      return {
        'status': 'success',
        'message': 'Rotated the drawing.'
      }
    }
  }
  catch (err) {
    return {
      'status': 'failed',
      'message': 'Failed to rotate the drawing.' + err.message
    }
  }
}

/**
 * Scale the loaded 2D drawing on x and y axis using drawing id.
 * @param {string} drawingId Pass the drawing id for scaling the drawing
 * @param {Number} scalingValue Pass the value to scale the drawing
 * @returns {Object} Return success or error messages 
 */
export function scaleDrawing(drawingId, scalingValue) {
  try {
    let scope = this;
    if (scope.canvas && scope.canvas.children.length != 0 && scalingValue > 0) {
      d3.select('#' + scope.canvas.id).selectAll('#group').each(function () {
        if (scope.getAttribute('name') === drawingId) {
          let previousTranslation = scope.getAttribute('transform');
          d3.select(this)
            .attr('transform', previousTranslation + 'scale(' + scalingValue + ')');
        }
      });
      return {
        'status': 'success',
        'message': 'Scaled the drawing.'
      }
    }
  }
  catch (err) {
    return {
      'status': 'failed',
      'message': 'Failed to scale the drawing.' + err.message
    }
  }
}